import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Scenario & Knowledge
export const getScenario = () => api.get("/scenario");
export const getPersonas = () => api.get("/personas");

// Simulation
export const startSimulation = (scenarioId = "helios_capital", startingPersona = null) =>
  api.post("/simulation/start", { scenario_id: scenarioId, starting_persona: startingPersona });

export const sendMessage = (sessionId, message) =>
  api.post("/simulation/chat", { 
    session_id: sessionId, 
    message
  });

export const getSimulationState = (sessionId) =>
  api.get(`/simulation/${sessionId}/state`);

export const endSimulation = (sessionId) =>
  api.post(`/simulation/${sessionId}/end`);

export const getReport = (sessionId) =>
  api.get(`/simulation/${sessionId}/report`);

export const acknowledgeCoach = (sessionId, interventionId) =>
  api.post(`/simulation/${sessionId}/acknowledge-coach?intervention_id=${interventionId}`);

export const pollCoachFeedback = (sessionId) =>
  api.get(`/simulation/${sessionId}/coach-poll`);

export const getSuggestion = (sessionId, quality) =>
  api.post(`/simulation/${sessionId}/suggestions`, { quality });

export const voiceChat = (sessionId, audioBlob) => {
  const formData = new FormData();
  formData.append("audio", audioBlob, "recording.webm");
  return api.post(`/simulation/${sessionId}/voice-chat`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
};

export const textToSpeech = (text, personaId) =>
  api.post("/tts", { text, persona_id: personaId });

export const testVoiceChat = (sessionId, quality) =>
  api.post(`/simulation/${sessionId}/test-voice`, { quality }, { timeout: 60000 });

// Multi-stakeholder endpoints
export const getInterimSummary = (sessionId) =>
  api.post(`/simulation/${sessionId}/interim-summary`);

export const switchPersona = (sessionId, targetPersona) =>
  api.post(`/simulation/${sessionId}/switch-persona`, { target_persona: targetPersona });

// Persona image URLs from design guidelines
export const PERSONA_IMAGES = {
  jamie_sterling: "https://images.unsplash.com/photo-1762522926157-bcc04bf0b10a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1hbiUyMGhlYWRzaG90JTIwY29ycG9yYXRlfGVufDB8fHx8MTc3MjcxODEyOXww&ixlib=rb-4.1.0&q=85&w=200",
  evelyn_reed: "https://images.unsplash.com/photo-1765005204058-10418f5123c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwaGVhZHNob3QlMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzcyNzE4MTI4fDA&ixlib=rb-4.1.0&q=85&w=200",
  ben_carter: "https://images.unsplash.com/photo-1771898343647-bd979ad8cca5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1hbiUyMGhlYWRzaG90JTIwY29ycG9yYXRlfGVufDB8fHx8MTc3MjcxODEyOXww&ixlib=rb-4.1.0&q=85&w=200",
};

// MEDDPICC dimension info with Platypai palette colors
export const MEDDPICC_LABELS = {
  M: { name: "Metrics", color: "#0F3559" },
  E: { name: "Economic Buyer", color: "#6B3868" },
  D1: { name: "Decision Criteria", color: "#E01C4A" },
  D2: { name: "Decision Process", color: "#E0A800" },
  P: { name: "Paper Process", color: "#7D8CA3" },
  I: { name: "Identify Pain", color: "#4ECDC4" },
  C1: { name: "Champion", color: "#FFD557" },
  C2: { name: "Competition", color: "#1E68AE" },
};

// Phase info
export const PHASE_INFO = {
  P1: { name: "Discovery & Diagnosis", color: "blue" },
  P2: { name: "Qualification & Alignment", color: "purple" },
  P3: { name: "Validation & Proposal", color: "amber" },
  P4: { name: "Commitment & Closure", color: "emerald" },
  COMPLETE: { name: "Complete", color: "green" },
  FAILED: { name: "Failed", color: "red" },
};

// Trust level info
export const getTrustLevel = (score) => {
  if (score <= 40) return { level: "Defensive", color: "red" };
  if (score <= 60) return { level: "Neutral", color: "yellow" };
  if (score <= 80) return { level: "Engaged", color: "emerald" };
  return { level: "Advocate", color: "blue" };
};
